import React, { useContext } from 'react';

import { SpaceBetween, Popover, StatusIndicator, Button, Box } from '@amzn/awsui-components-react-v3';

import { ValueWithLabel } from 'src/components/Utils';
import { Context } from 'src/store';
import { Serial } from 'src/store/types';

import { QuantityProps } from './types';

export const ReceivingQuanityCell = ({ model }: QuantityProps) => {
  const { state } = useContext(Context);

  const allSerials: Serial[] = state?.serials?.filter((serial: Serial) => serial.mpnIpnId === model?.mpnIpnId);

  return <Box>{allSerials?.length || 0}</Box>;
};

export const ReceivingQuanity = ({ receivingQty }: { receivingQty: number }) => {
  return (
    <ValueWithLabel
      label={
        <SpaceBetween direction="horizontal" size="xxxs">
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content={
              <StatusIndicator type="info">
                Total number of serials currently receiving now for this MPN
              </StatusIndicator>
            }
          >
            <Button ariaLabel="receiving-qty-info" iconName="status-info" variant="icon" />
          </Popover>
          <Box variant="awsui-key-label">Receiving Qty.</Box>
        </SpaceBetween>
      }
    >
      <Box margin={{ left: 'l' }}>{receivingQty}</Box>
    </ValueWithLabel>
  );
};
